import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlagsService } from 'src/app/services/flags.service';
import { Router } from '@angular/router';
import { URLService } from 'src/app/services/dynamic-url.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TooltipDirective } from 'src/app/standalones/directives/pncl-tooltip.directive';
import { PencilIconComponent } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-dev-panel',
  standalone: true,
  imports: [CommonModule, TooltipDirective, PencilIconComponent],
  templateUrl: './dev-panel.component.html',
  styleUrls: ['./dev-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevPanelComponent {
  isCustomFlagsEnabled$ = this.flagsService.isCustomFlagsEnabled;
  customServeUrls: { [key: string]: string } = {};

  isExpanded = new BehaviorSubject<boolean>(true);
  isExpanded$ = this.isExpanded.asObservable();

  constructor(
    private flagsService: FlagsService,
    public router: Router,
    private uRLService: URLService,
  ) {
    this.uRLService.customServerUrls.pipe(untilDestroyed(this)).subscribe((customUrls) => {
      this.customServeUrls = customUrls;
    });
  }

  toggleExpand() {
    this.isExpanded.next(!this.isExpanded.value);
  }

  resetServerUrl() {
    this.uRLService.resetUrls();
    this.customServeUrls = {};
    document.body.style.paddingTop = '0';
  }

  resetFlags() {
    this.flagsService.resetFlags();
    window.location.reload();
  }
}
